import script from "./LoginExpired.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginExpired.vue?vue&type=script&setup=true&lang=js"

import "./LoginExpired.vue?vue&type=style&index=0&id=6f25b77f&scoped=true&lang=css"

import exportComponent from "/Users/gordonwong/Shedd/aerocle-client/aerocle-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f25b77f"]])

export default __exports__